import { useIntl } from 'react-intl';

import { useAppSelector } from '@/shared/hooks';
import { getName } from '@/shared/lib';

import { getOrganizationDoctorsRoles } from '@/entities/organization';
import { userModel } from '@/entities/user';

import { getAvatarSrcByUserID } from '../../assets';
import { DoctorInterface } from '../config';
import { getOrganizationDoctorSpecializations } from '../lib/getOrganizationDoctorSpecializations';
import * as organizationModel from '../model';

export const useGetOrganizationDoctorsInterfaces = (): DoctorInterface[] => {
  const allOrganizationDoctors = useAppSelector(
    organizationModel.selectors.selectAllUsers,
  );

  const userLocale = useAppSelector(userModel.selectors.selectUserLocale);

  const { formatMessage } = useIntl();

  const staffStatusOrder: Record<string, number> = {
    Active: 0,
    Deleted: 1,
  };

  const orgDoctors: DoctorInterface[] = allOrganizationDoctors?.length
    ? [...allOrganizationDoctors]
        .sort(
          (a, b) =>
            (staffStatusOrder[a.Status?.case ?? ''] ?? 1) -
            (staffStatusOrder[b.Status?.case ?? ''] ?? 1),
        )
        .map((doctor) => {
          // TODO: Need to update the avatar src
          const avatarSrc = getAvatarSrcByUserID(
            doctor.UserID ?? '',
            'thumbnail',
          );
          const doctorName = getName(
            doctor.PersonalData?.FirstName,
            doctor.PersonalData?.LastName,
            { userLocale },
          );
          const doctorInitials = getName(
            doctor.PersonalData?.FirstName,
            doctor.PersonalData?.LastName,
            { userLocale, shortFirstName: true, shortLastName: true },
          );

          return {
            id: doctor.UserID ?? '',
            avatarSrc,
            fullName: doctorName,
            email: doctor?.PersonalData?.Email ?? '',
            specializations: getOrganizationDoctorSpecializations(
              doctor.JobPositions,
              formatMessage,
            ),
            roles: getOrganizationDoctorsRoles([doctor.Role], formatMessage),
            doctorInfo: doctor,
            initials: doctorInitials,
            isDeleted: doctor.Status?.case === 'Deleted',
          };
        })
    : [];

  return orgDoctors;
};
